import React, { useEffect } from "react";
import { useMediaQuery } from "discover.medical.react-component-library";
import { useStore, useDispatch } from "../../store";
import { fetchCmeButtonInfo } from "../../store/actions/ceCmeButton";
import ErrorBoundary from "../ErrorBoundary";
import CmeButton from "../CmeButton";

function CEButtonWidget() {
  const isTablet = useMediaQuery("min", "sm");
  const dispatch = useDispatch();
  const { cmeButton } = useStore();

  useEffect(() => {
    fetchCmeButtonInfo(dispatch);
  }, [dispatch]);

  const {
    buttonLabel = "",
    buttonUrl = "",
    isExternalNavigation = false,
    availableCreditsCount = null,
  } = cmeButton;

  if (!Object.keys(cmeButton).length) {
    return null;
  }

  const buttonSize = isTablet ? "md" : "sm";

  return (
    <ErrorBoundary team="cd.ghostriders">
      <div data-testid="header-ce">
        <CmeButton
          buttonSize={buttonSize}
          buttonUrl={buttonUrl}
          buttonLabel={buttonLabel}
          availableCreditsCount={availableCreditsCount}
          isExternalNavigation={isExternalNavigation}
        />
      </div>
    </ErrorBoundary>
  );
}

export default CEButtonWidget;
